module.exports = __webpack_public_path__ + "static/img/main_point_img10.6bcde895.svg";